import { getChannelSSASuggestions } from 'app/syndicatedSponsoredAds/services/autosuggestServices';
import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';

export default withAutosuggestWrapper(withInputErrorMessage(autosuggestFactory({
   apiPromise: getChannelSSASuggestions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Channel...',
})));
